export default __webpack_public_path__ + "static/media/react.230238bf.png";